import { ReferenceData } from './reference-data.model';

export class NavigationItem extends ReferenceData {
  RouterLink: Array<string>;
  Disabled: boolean;
  Description: string;
  TagId: string;
  Action: (context: any) => void;
}
